import api from 'axios'
import { URL_BACK } from '../../variableProd'
/**
 * Servicio para autenticación y administración de usuarios.
 * @module ServicioUsuarios
 */
const logIn = URL_BACK + '/usuario/login.php'
const cierraSesion = URL_BACK + '/usuario/logoutUsuario.php'
const registro = URL_BACK + '/usuario/registro.php'
const update = URL_BACK + '/usuario/update.php'
const getUsuario = URL_BACK + '/usuario/getUsuario.php'
const getUsuarios = URL_BACK + '/usuario/getUsuarios.php'

// const getmisUsuarios = URL_BACK + '/usuario/getUsuarios'
const deletemiUsuario = URL_BACK + '/usuario/eliminarUsuario'
const privilegio = URL_BACK + '/usuario/editarPrivilegioReactivar'
/**
 * Funciones para autenticación y administración de usuarios.
 */

export default {
  /**
   * Inicia sesión de un usuario.
   * @param {object} model - Modelo de inicio de sesión.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  logIn (model) {
    return new Promise((resolve, reject) => {
      api
        .post(logIn, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
   /**
   * Cierra la sesión de un usuario.
   * @param {object} model - Modelo de cierre de sesión.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  /*
  logOut (model) {
    return new Promise((resolve, reject) => {
      api
        .post(logOut, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  */
  /**
   * Registra un nuevo usuario.
   * @param {object} model - Modelo de registro de usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  registro (model) {
    return new Promise((resolve, reject) => {
      api
        .post(registro, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Update un nuevo usuario.
   * @param {object} model - Modelo de Update de usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  update (model) {
    return new Promise((resolve, reject) => {
      api
        .post(update, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  /**
   * Obtiene lista de usuarios.
   * @param {object} model - Modelo de obtener a usuarios.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  getUsuario (model) {
    return new Promise((resolve, reject) => {
      api
        .post(getUsuario, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  /**
   * Obtiene lista de usuarios.
   * @param {object} model - Modelo de obtener a usuarios.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  getUsuarios (model) {
    return new Promise((resolve, reject) => {
      api
        .post(getUsuarios, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Cierra sesion de  usuario.
   * @param {object} model - Modelo de usuario a cerrar sesion.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  cerrarSesion (model) {
    return new Promise((resolve, reject) => {
      api
        .post(cierraSesion, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Editar privilegio a un usuario.
   * @param {object} model - Modelo de editar privilegio a  usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  editarPrivilegio (model) {
    return new Promise((resolve, reject) => {
      api
        .post(privilegio, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Eliminar un usuario.
   * @param {object} model - Modelo de Eliminar de  un usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  deleteUsuarios (model) {
    return new Promise((resolve, reject) => {
      api
        .delete(deletemiUsuario, {data:model})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
    
}

